import { ACTION_TYPES } from "../actions/order";

const initialState = {
    orders: [],
    metaOrder: {},
    orderCounts: {}
}

export const order = (state = initialState, action) => {
    switch (action.type) {
        case ACTION_TYPES.ORDER_FETCH_ALL:
            return {
                ...state,
                orders: [...action.payload]
            }
        case ACTION_TYPES.ORDER_FETCH_COUNT:
            return {
                ...state,
                orderCounts: action.payload
            }
        case ACTION_TYPES.ORDER_CREATE:
            return {
                ...state,
                orders: [...state.orders, action.payload]
            }
        case ACTION_TYPES.ORDER_UPDATE:
            return {
                ...state,
                orders: state.orders.map(x => x.id === action.payload.id ? action.payload : x)
            }
        case ACTION_TYPES.ORDER_DELETE:
            return {
                ...state,
                orders: state.orders.filter(x => x.id !== action.payload)
            }
        case ACTION_TYPES.ORDER_PAGINATION:
        
            return {
                ...state,
                orders: [...action.payload.orders],
                metaOrder: action.payload.meta
            }
        default:
            return state;
    }
}